import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';
import { updatePlacesPagination } from '../../store/actions/place/place_action';
import { REACT_ROUTES } from '../../constants/react_routes';
import SearchComponent from '../ui_components/search';
import history from '../../services/history';
import PlacesTable from './places_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const PlaceList = ({ places }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = places;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updatePlacesPagination({...places, page: 0, filters: { ...filters, search }}))
    }

    const handleAddPlaceClick = () => {
        history.push(REACT_ROUTES.PLACE);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Mesta
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddPlaceClick}
                    >
                        Kreirajte novo mesto
                    </Button>
                </Grid>
            </Grid>
            <PlacesTable/>
        </Container>
    )
}

PlaceList.propTypes = {
    places: PropTypes.object
}

const mapStateToProps = (state) => ({
    places: state.places
});

export default connect(mapStateToProps)(PlaceList);
